import { memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SidebarItem = memo(({ item, isExpanded, onItemClick }) => {
  const { t } = useTranslation();
  
  return (
    <Link 
      to={item.path} 
      state={{ from: 'sidebar' }}
      className="nav-link d-flex align-items-center"
      title={!isExpanded ? t(item.translationKey) : ''}
      onClick={onItemClick}
    >
      {/* <i className="bi bi-file-text me-2"></i> */}
      {isExpanded && <span className="text-truncate">{t(item.translationKey)}</span>}
    </Link>
  );
});

SidebarItem.displayName = 'SidebarItem';
export default SidebarItem; 